<div class="flex items-center justify-end gap-2">
  <!-- Download Button -->
  <button
    class="btn btn-text-only"
    [disabled]="!canDownload() || loading() || !hasDownload()"
    [title]="getDownloadTitle() | translate"
    [attr.aria-label]="
      'pages.articles.actionButtons.downloadArticle' | translate
    "
    (click)="onDownload()"
  >
    @if (isLabeled()) {
      <span>
        {{ 'pages.articles.actionButtons.downloadArticle' | translate }}
      </span>
    }
    @if (!(loading() && canDownload())) {
      <!-- <img src="assets/icons/download-article.svg" alt="" class="h-6 w-6" /> -->
      <svg
        class="h6 w-6"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 16L16 11H13V4H11V11H8L12 16Z" fill="currentColor" />
        <path
          d="M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z"
          fill="currentColor"
        />
      </svg>
    } @else {
      <svg
        class="h-6 w-6 animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        ></path>
      </svg>
    }
  </button>
  <!-- Print Button -->
  <button
    class="btn btn-text-only"
    [disabled]="!canAccess()"
    [title]="
      (canAccess()
        ? 'pages.articles.actionButtons.printAuthenticatedTooltip'
        : 'pages.articles.actionButtons.printUnauthenticatedTooltip'
      ) | translate
    "
    [attr.aria-label]="'pages.articles.actionButtons.printArticle' | translate"
    (click)="onPrint()"
  >
    @if (isLabeled()) {
      <span>
        {{ 'pages.articles.actionButtons.printArticle' | translate }}
      </span>
    }
    <!-- <img src="assets/icons/printer.svg" alt="" class="h-6 w-6" /> -->
    <svg
      class="h-6 w-6"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 5.5H16V0.5H4V5.5H3C1.346 5.5 0 6.846 0 8.5V15.5C0 16.603 0.897 17.5 2 17.5H4V20.5H16V17.5H18C19.103 17.5 20 16.603 20 15.5V8.5C20 6.846 18.654 5.5 17 5.5ZM6 2.5H14V5.5H6V2.5ZM14 18.5H6V14.5H14V18.5ZM18 15.5H16V12.5H4V15.5H2V8.5C2 7.949 2.449 7.5 3 7.5H17C17.552 7.5 18 7.949 18 8.5V15.5Z"
        fill="currentColor"
      />
      <path d="M12 8.5H16V10.5H12V8.5Z" fill="currentColor" />
    </svg>
  </button>
  <!-- Share Button -->
  <button
    class="btn btn-text-only"
    [title]="'pages.articles.actionButtons.shareArticleTooltip' | translate"
    [attr.aria-label]="'pages.articles.actionButtons.shareArticle' | translate"
    (click)="onShare()"
  >
    @if (isLabeled()) {
      <span>
        {{ 'pages.articles.actionButtons.shareArticle' | translate }}
      </span>
    }
    <!-- <img src="assets/icons/share.svg" alt="" class="h-6 w-6" /> -->
    <svg
      class="h-6 w-6"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9997 7.55V4.5C10.9997 4.23478 10.8943 3.98043 10.7068 3.79289C10.5193 3.60536 10.2649 3.5 9.9997 3.5C9.73736 3.5011 9.48597 3.60526 9.2997 3.79L2.2997 10.79C2.20598 10.883 2.13158 10.9936 2.08081 11.1154C2.03004 11.2373 2.00391 11.368 2.00391 11.5C2.00391 11.632 2.03004 11.7627 2.08081 11.8846C2.13158 12.0064 2.20598 12.117 2.2997 12.21L9.2997 19.21C9.44009 19.3476 9.61792 19.4408 9.81096 19.4779C10.004 19.515 10.2037 19.4944 10.3851 19.4186C10.5665 19.3429 10.7215 19.2153 10.8308 19.0519C10.9402 18.8886 10.9989 18.6966 10.9997 18.5V15.4H11.8497C13.4296 15.3764 14.9957 15.697 16.4394 16.3393C17.883 16.9817 19.1695 17.9306 20.2097 19.12C20.3351 19.2869 20.5095 19.4104 20.7085 19.4731C20.9076 19.5359 21.1213 19.5348 21.3197 19.47C21.5216 19.4019 21.6965 19.271 21.8188 19.0965C21.9411 18.922 22.0045 18.713 21.9997 18.5C21.9997 9.38 13.9197 7.82 10.9997 7.55ZM11.8497 13.38C11.1809 13.3779 10.5126 13.4213 9.8497 13.51C9.61296 13.5459 9.39697 13.6656 9.24099 13.8473C9.08501 14.0289 8.99939 14.2606 8.9997 14.5V16.09L4.4197 11.5L8.9997 6.91V8.5C8.9997 8.76522 9.10506 9.01957 9.2926 9.20711C9.48013 9.39464 9.73449 9.5 9.9997 9.5C10.9097 9.5 18.1097 9.7 19.6697 15.93C17.4054 14.2606 14.6629 13.3663 11.8497 13.38Z"
        fill="currentcolor"
      />
    </svg>
  </button>
</div>
